import type { PlazaAvatar } from "@/features/plaza/types";

// Owner-selected photos, ordered to match the eight supplied references.
export const featuredAvatars = [
  {
    "id": "4c2f81c76a9b15cc00f98a27738ff5f9",
    "name": "旺哥Max",
    "src": "/avatar-stills/8ff5f9-3-c119e5443d3f.webp"
  },
  {
    "id": "a9defcfd6aa2c46a012853f3589f1aab",
    "name": "小程程",
    "src": "/avatar-stills/9f1aab-2-ae38b328d3a3.webp"
  },
  {
    "id": "a9defcfd6aa0b8c001103d747ef8acd9",
    "name": "阿飞",
    "src": "/avatar-stills/f8acd9-1-a1801206537d.webp"
  },
  {
    "id": "b5138c476a7acdd601d8a8a13a92d9f8",
    "name": "饱饱",
    "src": "/avatar-stills/92d9f8-3-8263440be370.webp"
  },
  {
    "id": "6e56a4026a587e7800b3e3bc28907462",
    "name": "呆呆",
    "src": "/avatar-stills/907462-1-b1e41c362bbd.webp"
  },
  {
    "id": "6e56a4026a55b277008126a904d569f7",
    "name": "鱼籽酱",
    "src": "/avatar-stills/d569f7-2-8b3e75873023.webp"
  },
  {
    "id": "6e56a4026a571f0a009ad1815ea70e0d",
    "name": "李融融",
    "src": "/avatar-stills/a70e0d-1-adb68f33e03a.webp"
  },
  {
    "id": "6d758f346a70690e00b0a5e52092c93d",
    "name": "雾月十八日",
    "src": "/avatar-stills/92c93d-3-9c709cac7a58.webp"
  }
] as const;

export function featuredHomeImages(avatars: PlazaAvatar[]) {
  return featuredAvatars.flatMap(selection => {
    const avatar = avatars.find(item => item.id === selection.id);
    if (!avatar) return [];
    const photos = [...avatar.lifePhotoUrls, ...(avatar.stillPhotoUrls ?? [])];
    const src = photos.find(url => url === selection.src || (url.startsWith("https://") && new URL(url).pathname === selection.src));
    // These selected assets ship with the site; keep image requests same-origin.
    return src ? [{ id: avatar.id, name: avatar.title, src: selection.src }] : [];
  });
}
